export default __webpack_public_path__ + "static/media/carousel-img-4.0506e810.webp";